import React from 'react'
import { Main } from '@/components/Layout'
import Announcements from './announcements'
import context from '@/context'
import Widgets from '@/components/dashboard/widgets'

function Dashboard () {
  return (
    <Main className='dashboard'>
      <div className='row'>
        <Announcements />
        <Widgets widgetComponents={context.widgets} />
      </div>
    </Main>
  )
}

export {
  Dashboard
}



// WEBPACK FOOTER //
// ./src/components/dashboard/index.js